import type { UpdateCommentDto } from '@getaccept/lib-shared/src/contextual-commenting/types/update-comment-dto';

export const getCommentsWithNewEditorBlockVersion = (
  comments: UpdateCommentDto[],
  idVersionMap: Record<string, string>
) => ({
  comments: comments.map(comment => ({
    ...comment,
    editorSelection: {
      ...comment.editorSelection,
      editorBlockVersion: idVersionMap[comment.editorSelection.editorBlockId],
    },
  })),
});
